import { useContext, useState } from 'react';
import { UserRound } from 'lucide-react';

import { NAVBAR_ICON_URL } from '@/constants';
import { Button } from '@/components/ui/button';
import { InstallationDialog, isSafari } from '@/views/home/Home';

import styles from './Home.module.css';

import LatestIssue from './components/LatestIssue';
import Issues from './components/Issues';
import FeedIssue from './components/FeedIssue';
import { AppContext } from '@/App.context';
import { HomeContext } from './Home.context';
import { isStandAlone } from '@/views/installation/Installation';
import { useAd } from '../App.hooks';

export function Home() {
	const [showInstallation, setShowInstallation] = useState(false);
	return (
		<HomeContext.Provider
			value={{
				showInstallation,
				setShowInstallation: (v: boolean) => {
					setShowInstallation(v);
				},
			}}
		>
			<InstallationDialog
				setShowInstallation={setShowInstallation}
				show={showInstallation}
			/>
			<div className={styles['view']}>
				<nav>
					<div />
					<div>
						<img src={NAVBAR_ICON_URL} />
					</div>

					<div className="flex items-center justify-end pr-4">
						<ProfileBtn />
						<SubscribeBtn />
						<InstallBtn />
					</div>
				</nav>
				<main>
					<LatestIssue />
					<Content />
				</main>
			</div>
		</HomeContext.Provider>
	);
}

function InstallBtn() {
	const { isSupportInstallPrompt, deferredPrompt } = useContext(AppContext);
	const { setShowInstallation } = useContext(HomeContext);
	if (isStandAlone()) {
		return null;
	}
	if (!isSafari() && !isSupportInstallPrompt) {
		return null;
	}

	if (!isSafari() && deferredPrompt === undefined) {
		return null;
	}

	if (!isSupportInstallPrompt || !deferredPrompt) {
		return (
			<Button
				className={`${styles['install-btn']}`}
				onClick={() => {
					setShowInstallation(true);
				}}
			>
				Install
			</Button>
		);
	}

	return (
		<Button
			className={`${styles['install-btn']}`}
			onClick={() => {
				deferredPrompt.prompt();
			}}
		>
			Install
		</Button>
	);
}

function SubscribeBtn() {
	return (
		<Button
			variant={'outline'}
			className={`${styles['subscribe-btn']} mr-4 ml-4`}
			onClick={() => {
				console.log(`On click`);
			}}
		>
			Subscribe
		</Button>
	);
}

export function ProfileBtn() {
	return (
		<Button
			variant="secondary"
			size="icon"
			className={`cursor-pointer size-8 ${styles['profile-btn']} `}
		>
			<UserRound />
		</Button>
	);
}

function Content() {
	return (
		<section className={`${styles['content']} pt-4`}>
			<AdBanner />
			<Issues />
			<FeedIssue
				title={'Exclusive News'}
				issueId={1519}
				showTitle={true}
				limit={10}
			/>
			<FeedIssue
				title={'Games'}
				issueId={1520}
				showTitle={false}
				limit={10}
			/>
		</section>
	);
}

function AdBanner() {
	const id = 'home-banner';
	useAd({
		id,
		slot: '/23214115701/Star_homepage_Top_LB',
		sizes: [
			[728, 90],
			[320, 50],
		],
	});
	return (
		<div
			id={id}
			className={`${styles['banner']} mx-auto mt-4 mb-4 flex justify-center items-center`}
		/>
	);
}
